<template>
  <div class="card">
    <div class="bg-blue-light p-1">
      <TitleButton
          btnTitle="Add New"
          :showBtn="true"
          :showAddNew="false"
          :title="title"
          @onClickCloseButton="onClickCloseButton"
      >
      </TitleButton>
    </div>

    <div class="col-12 px-2 mt-2">
      <div class="px-2">
        <DateQuerySetter
            btnTitle="Go"
            @onClickGo="onClickGo"
        >
          <div class="col-12 col-sm-6 col-md-4 col-lg-3 mr-top-1">
            <label class="form-label">Business Unit</label>
            <v-select
                placeholder="Select Business"
                v-model="businessId"
                :options="business"
                label="name"
                :reduce="name => name.id"
            />
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3">

            <div class="d-flex align-items-center justify-content-between filter-label">
              <label for="colFormLabel" class="col-form-label">Party: </label>
              <span class="filter-search-icon cursor-pointer" @click="onOpenContactSearchModal">
                            <i class="fas fa-search"></i>
                        </span>
            </div>

            <AsyncSelect
                placeholder="Select Party"
                v-model="contactProfile"
                :api-service="fetchContactProfiles"
                :additional-query="additionalContactOption"
                :reduce="text => text.id"
            />
          </div>

        </DateQuerySetter>
      </div>

      <div class="col-12 px-2">
        <div class="card pipeline-list pt-2">
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
              <tr>
                <th>Job Details</th>
                <th>Service</th>
                <th>Assigned Team</th>
                <th>Agreement Date</th>
                <th>Job Stage</th>
                <th>Job Status</th>
                <th>Completion Date</th>
                <th>Actions</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in tableItems" :key="index">
                <td>
                  <div class="job-title">{{ item.name }}</div>
                  <div class="client-name">{{ item.party_name }}</div>
                </td>

                <td>
                  <div class="service-name">{{ item.service_names }}</div>
                  <div class="business-unit">{{ item.business_name }}</div>
                </td>

                <td>
                  <div class="team-member">
                    <div  v-for="(team, index) in item.project_teams">
                      <img class="avatar" :src="team.photo" alt="">
                    </div>
                    <div>
                      <div class="team-name">{{ item.key_account_manager_name }} </div>
                    </div>
                  </div>
                </td>

                <td>
                  <div class="date-main">{{ item.bill_date }}</div>
                  <div class="date-sub">Start: {{ item.start_date }}</div>
                  <div class="date-sub">End: {{ item.end_date }}</div>
                </td>
                <td>{{ item.job_stage_name }}</td>
                <td></td>
                <td>{{ item.completed_date_time }}</td>
                <td>
                  <button class="btn btn-primary btn-sm" @click="goToRegisterPage(item)">
                    <i class="fa fa-eye"></i>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>

            <p v-if="!tableItems.length" class="text-center mt-5">No data</p>
          </div>
        </div>

        <div class="px-2 bottom-0 mt-2">
          <Pagination
              :offset="offset"
              @onPageChange="onPageChange"
              ref="pagination"
          />
        </div>
      </div>

      <ContactDropdownFilter
          v-if="store.state.isModalOpenThree"
          @onSearchContact="onSearchContact"
          :companyRoles="companyRoles"
          :isFilterable="true"
      />

        <Loader v-if="loading"/>
      </div>
    </div>
</template>

<script setup>
import {ref, onMounted, computed, inject, watch} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from "vuex";
import Loader from "@/components/atom/LoaderComponent.vue";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import DateQuerySetter from '@/components/atom/DateQuerySetter.vue';
import Pagination from '@/components/atom/Pagination';
import handleContact from "@/services/modules/contact";
import handleProjects from "@/services/modules/procurement/project";
import handleHospital from '@/services/modules/hospital';
import TitleButton from '@/components/molecule/company/crm/visit-plan/VisitTitle.vue';
import ContactDropdownFilter from '@/components/atom/Contact/ContactDropdownFilter.vue'
import handleRole from "@/services/modules/role";

const { fetchContactProfiles } = handleContact();
const { fetchNoteMasterList } = handleHospital();
const { fetchCompanyDefaultRoles } = handleRole();
const { fetchJobTrackerData } = handleProjects();

const route = useRoute();
const router = useRouter();
const store = useStore();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false);

const start = computed(() => route.query.start);
const end = computed(() => route.query.end);
const page = computed(() => route.query.page);
const jobStageId = computed(() => route.query.job_stage_id);
const type = computed(() => route.query.type);
const statusType = computed(() => route.query.status_type);
const companyId = computed(() => route.params.companyId);

const tableItems = ref([]);
const offset = ref(10);
let permittedAccess = ref({})

const title = ref(null);
const clientId = ref(null);
const contactProfile = ref(null);
const additionalContactOption = ref({
  with_mobile: 1,
  dealer_id: '',
  roles: 'customer,lead'
});
const companyRoles = ref(null);
const businessId = ref(null);
let business = ref([])

const onClickGo = () => {
  getAllListData();
}

const onOpenContactSearchModal = () => {
  store.state.isModalOpenThree = true;
}

const onSearchContact = (contact) => {
  contactProfile.value = contact
}

const onPageChange = async (page) => {
  let routeQuery = { ...route.query }
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getAllListData()
}

const setPaginationData = (data) => {
  store.commit('setPaginationData', data)
}

const setPagination = (data) => {
  setPaginationData({
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const goToRegisterPage = (item) => {
  let routeQuery = { ...route.query };
  routeQuery.projectId = item.id;

  const routeData = router.resolve({
    name: 'job-register',
    query: routeQuery
  });

  window.open(routeData.href, '_blank');
};

const getAllListData = async () => {
  loading.value = true;
  const query = getQuery();
  tableItems.value = [];
  try {
    const res = await fetchJobTrackerData(query);
    if (!res.status) {
      showError(res.message);
      return store.commit("resetPagination")
    }
    tableItems.value = res.data.data.data;
    title.value = "Job Tracker- " + res.data.title
    setPagination(res.data.data)
  } catch (err) {
    console.error(err);
  } finally {
    loading.value = false;
  }
};

const getQuery = () => {
  let query = '?company_id=' + companyId.value
  query += '&offset=' + offset.value
  if (page.value) query += '&page=' + page.value
  if (start.value) query += '&start_date=' + start.value
  if (end.value) query += '&end_date=' + end.value
  if(type.value) query += '&type=' + type.value
  if(statusType.value) query += '&status_type=' + statusType.value
  if(jobStageId.value) query += '&job_stage_id=' + jobStageId.value
  if(clientId.value) query += '&client_id=' + clientId.value
  if(businessId.value) query += '&business_id=' + businessId.value
  return query
};

const onClickCloseButton = () => {
  const routeName = 'job-tracker';

  const typeTabMap = {
    'overview': 'overview',
    'recent_activity': 'recent_activity',
    'all_list': 'all_list'
  };

  const query = {
    start: route.query.start,
    end: route.query.end,
    ...(typeTabMap[route.query.type] && { tab: typeTabMap[route.query.type] })
  };

  const { ...params } = route.params;

  router.push({
    name: routeName,
    params,
    query
  });
};

onMounted( () => {
  Promise.all([
    getAllListData(),
  ])
})
</script>

<style scoped>
.mr-top-1 {
  margin-top: 1% !important;
}
.job-title {
  font-weight: 600;
  color: #1a3c5e;
  font-size: 0.88rem;
}
.service-name {
  font-weight: 500;
  color: #1f3f5c;
}
.team-member {
  display: flex;
  align-items: center;
  gap: 9px;
}

.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  color: #fff;
  font-size: 0.68rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  letter-spacing: 0.03em;
}

.team-name {
  font-weight: 600;
  font-size: 0.85rem;
}
.date-main {
  font-weight: 500;
  font-size: 0.86rem;
}
</style>